import moment from "moment";
import { jsPDF } from "jspdf";
import ExcelJS from "exceljs";
class ReportFunctions {

    fileDepositPopular(data) {
        let sequence = '1';
        let company_rnc = data[0].business_unit_rnc == undefined ? '?' : data[0].business_unit_rnc;
        let total = parseFloat(parseFloat(data[0].payment_transaction_amount).toFixed(2));
        let transaction_check_number = 1, invoice_quantity = data[0].payment_transaction_details.length;

          const currency_destiny={
            "USD": "840",
            "DOP": "214",
            "EUR": "978"
        }; 

        function document_code_type(document_id_type_id) {
            if(document_id_type_id===1){
                return 'RN'
            }else if(document_id_type_id===2){
                return 'CE'
            }
            return 'PA'
        }

        
        let txt = "H"
        txt += filRight(company_rnc.toString(), 15, ' ');
        txt += filRight(data[0].business_unit_description == undefined ? 'LM INDUSTRIES, S.A.' : data[0].business_unit_description, 35, ' ');
        txt += filLeft(sequence.toString(), 7, '0');
        txt += data[0].deposit_type == undefined ? "02" : filLeft(data[0].deposit_type.toString(), 2, '0');
        txt += moment(data[0].payment_date).format('YYYYMMDD');
        txt += filRight('0', 24, '0');
        txt += filLeft(invoice_quantity.toString(), 11, "0");
        txt += filLeft(total.toFixed(2).toString().replace('.', ''), 13, "0");
        txt += filRight('0', 15, '0');
        txt += moment().format('YYYYMMDDHHMM')
        txt += filRight(data[0].representative_email, 40, ' ');
        txt += filRight(' ', 137, " ") + "\n";
     
        for (var transaction of data[0].payment_transaction_details) {
           
            let email = transaction.entity_contact_json.find((element) => element.id_type === 5);
            txt += "N" + filRight(company_rnc.toString(), 15, ' ')//condicionarlo
                + filLeft(sequence.toString(), 7, '0')//cambiar
                + filLeft(transaction_check_number.toString(), 7, '0')
                + filRight(transaction.bank_account_description_short, 20, ' ')
                + transaction.account_type_id//revisar
                + currency_destiny[transaction.currency_code]//codigo de la moneda
                + (transaction.delivery_code||"10101070")//codigo del banco banco 
                + transaction.delivery_digit_code//banco popular
                + (transaction.account_type_id == "1" ? "22" : "32")// 1 ES CORRIENTE Y 2 ES AHORROS
                + filLeft(currencyFormat(transaction.payment_amount).replaceAll(',', '').replace('.', ''), 13, '0')
                + document_code_type(transaction.document_id_type_id)//TIPO DE DOCUMENTO 
                + filRight(transaction.entity_document_id, 15, ' ')//condicionar
                + filRight(deleteDiacriticos(transaction.entity_name.slice(0, 35)), 35, ' ')
                + filRight(' ', 56, ' ')//12 espacios numero de referencia, luego 40 de concepto de pago, 4 fecha de vencimiento, 1 forma de contacto,40 para el email,
                + (email == undefined ? ' ' : '1') 
                + filRight(email == undefined ? ' ' : email, 40, ' ')
                + filRight('0', 14, '0')//12 ceros del numero de telefono, 2 ceros uso futuro
                + filRight(' ', 79, ' ') + "\n";//numero que no sabemo 15, y 3 mas de un codigo de retorno, 3 de remoto, 3 razon interno, 1 de procesador de transaccion, 2 respuesta de validacion, 50 de nada
                for (let inv_detail of transaction.payment_transaction_invoice_details) {
                  
                    txt += "R" + filRight(company_rnc.toString(), 15, ' ');
                    txt += filLeft(sequence.toString(), 7, '0');
                    txt += filLeft(transaction_check_number.toString(), 7, '0');
                    txt += filRight(transaction.bank_account_description_short, 20, ' ');
                  //  txt += filLeft(inv_detail.invoice_number.slice(0, 15),15,' ');//revisar
                    txt += 'FC'+(filLeft(inv_detail.location_id.toString(),3,'0')+filLeft(inv_detail.number.toString(),10,'0'));
                    txt += '00'+moment(inv_detail.emission_date).format('YYYYMMDD');
                    // txt += filRight(currencyFormat(inv_detail.subtotal_amount).replaceAll(',', '').replace('.', ''), 13, '0');
                    // txt += filRight(currencyFormat(inv_detail.discount_amount).replaceAll(',', '').replace('.', ''), 11, '0');
                    // txt += filRight(currencyFormat(inv_detail.taxes_amount).replaceAll(',', '').replace('.', ''), 11, '0');
                    // txt += filLeft(currencyFormat(inv_detail.payment_amount).replaceAll(',', '').replace('.', ''), 13, '0');
                    txt += filRight(currencyFormat(inv_detail.payment_amount).replaceAll(',', '').replace('.', ''), 13, '0');
                    txt += filRight('0', 11, '0');
                    txt += filRight('0', 11, '0');
                    txt += filLeft(currencyFormat(inv_detail.payment_amount).replaceAll(',', '').replace('.', ''), 13, '0');
                    txt += filRight(('Fact.: '+deleteDiacriticos(inv_detail.supplier_invoice_number||'')).slice(0, 50),50,' ');
                    txt += filLeft(' ',147,' ');
                    txt += "\n";
                }
                transaction_check_number++;
        }
        return txt;

    }
    generarReportePago(pago) {
        const doc = new jsPDF();
        // Agrupa por suplidor + cuenta de banco (una página por cuenta).
        const grouped = pago.payment_details.reduce((acc, item) => {
            const key = [
                item.entity_id,
                item.bank_id != null ? item.bank_id : "",
                item.supplier_account != null ? item.supplier_account : "",
            ].join("||");
            if (!acc[key]) acc[key] = [];
            acc[key].push(item);
            return acc;
        }, {});

        let firstPage = true;

        Object.values(grouped).forEach((detalles,index) => {
            const ref = detalles[0];
            const totalFacturas = detalles.length;

            if (!firstPage) doc.addPage();
            firstPage = false;

            const destX = 120; // mover bloque derecho hacia la izquierda

            // === TITULO ===
            doc.setFont("helvetica", "bold");
            doc.setFontSize(14);
            doc.text(ref.business_unit_description, 105, 12, { align: "center" });

            doc.setFontSize(11);
            doc.text(ref.location_description, 105, 17, { align: "center" });

            doc.setFontSize(9);
            doc.text("DETALLES DEL PAGO", 105, 22, { align: "center" });

            doc.line(15, 25, 195, 25);

            // === DATOS GENERALES ===
            doc.setFont("helvetica", "normal");
            doc.setFontSize(8);

            doc.text(`ID de Pago: PS-${ref.entity_id}-${pago.invoice_payment_id}-${index + 1}`, 20, 31);
            doc.text(`Fecha de Pago: ${moment(pago.payment_date).format("DD/MM/YYYY")}`, destX, 31);

            doc.text(
                pago.check_number
                    ? `Tipo de Pago: ${pago.payment_type_name}  -  No. Cheque: ${pago.check_number}`
                    : `Tipo de Pago: ${pago.payment_type_name}`,
                20,
                35
            );
            doc.text(`Fecha impresión: ${moment().format('DD/MM/YYYY HH:mm')}`, destX, 35);

            doc.text(`Elaborado por: ${pago.payment_by_name}`, 20, 39);
            doc.text(`Facturas del suplidor: ${totalFacturas}`, destX, 39);

           // === ORIGEN / DESTINO ===
            const esCxP = pago.invoice_type_id === 1 || pago.invoice_type_id === 4; // Cuentas por pagar
            const esCxC = pago.invoice_type_id === 2 || pago.invoice_type_id === 3; // Cuentas por cobrar

                doc.setFont("helvetica", "bold");
                doc.text("Origen", 20, 45);
                doc.text("Destino", destX, 45);

                doc.setFont("helvetica", "normal");

                if (esCxP) {
                // origen empresa
                doc.text(`Cta. ${pago.bank_account_description_short || "No disponible"}`, 20, 49);
                doc.text(pago.bank_account_description_long || "", 20, 53);

                // Destino: Entidad
                doc.text(ref.entity_name, destX, 49);
                doc.text(
                    `${ref.document_id_type_name || ""}: ${ref.entity_document_id || "N/D"}`,
                    destX,
                    53
                );
                doc.text(`Cta. ${ref.supplier_account || "No disponible"}`, destX, 57);
                doc.text(ref.bank_description_long || "", destX, 61);
                if (ref.account_name) {
                    doc.text(`Resp.: ${ref.account_name}`, destX, 65);
                }

                } else if (esCxC) {
                // Cuentas por cobrar (invertido)
                // Origen: Entidad
                doc.text(ref.entity_name, 20, 49);
                doc.text(
                    `${ref.document_id_type_name || ""}: ${ref.entity_document_id || "N/D"}`,
                    20,
                    53
                );
                doc.text(`Cta. ${ref.supplier_account || "No disponible"}`, 20, 57);
                doc.text(ref.bank_description_long || "", 20, 61);
                if (ref.account_name) {
                    doc.text(`Resp.: ${ref.account_name}`, 20, 65);
                }

                // Destino: empresa
                doc.text(`Cta. ${pago.bank_account_description_short || "No disponible"}`, destX, 49);
                doc.text(pago.bank_account_description_long || "", destX, 53);
                }


            // === TABLA ===
            const columns = [
                "Factura",
                esCxP ? "Suplidor" : "Cliente",
                "Referencia",
                "Monto Total",
                "Balance Pendiente",
                "Total Pagado"
                ];

            const rows = detalles.map(item => [
            item.invoice_number,
            item.entity_name.slice(0, 30),
            item.supplier_invoice_number,
            `${currencyFormat(item.total_amount)} ${item.currency_code}`,
            `${item.total_pending_amount || "0.00"} ${item.currency_code}`,
            `${currencyFormat(item.transaction_amount)} ${pago.currency_code}`
            ]);

            doc.autoTable({
                startY: 70,
                head: [columns],
                body: rows,
                theme: "striped",
                styles: { fontSize: 7.5, cellPadding: 1.2, valign: "middle" },
                headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold", fontSize: 7.5 },
                alternateRowStyles: { fillColor: [245, 245, 245] },
                columnStyles: {
                    3: { halign: "right" },
                    4: { halign: "right" },
                    5: { halign: "right" }
                }
            });

            // === TOTAL / NOTA ===
            const totalEntidad = detalles.reduce((s, i) => s + Number(i.transaction_amount || 0), 0);
            const finalY = doc.lastAutoTable.finalY;

            // Nota solo si existe
            if (pago.note) {
            const noteX = 20;
            const noteY = finalY + 6;
            const noteWidth = 95;
            const noteHeight = 12;

            doc.setDrawColor(0);
            doc.setFillColor(245, 245, 245);
            doc.rect(noteX, noteY, noteWidth, noteHeight, "FD");

            doc.setFontSize(8);
            doc.setFont("helvetica", "bold");
            doc.text("Nota:", noteX + 2, noteY + 5);

            doc.setFont("helvetica", "normal");
            doc.text(
                doc.splitTextToSize(pago.note, noteWidth - 6),
                noteX + 2,
                noteY + 9
            );
            }

            // Total
            const boxX = 120;
            const boxY = finalY + 6;
            const boxWidth = 70;
            const boxHeight = 12;

            doc.setDrawColor(0);
            doc.setFillColor(235, 235, 235);
            doc.rect(boxX, boxY, boxWidth, boxHeight, "FD");

            doc.setFontSize(9);
            doc.setFont("helvetica", "bold");
            doc.text("Total Pagado:", boxX + 2, boxY + 7);

            doc.setFont("helvetica", "normal");
            doc.text(
            `${currencyFormat(totalEntidad)} ${pago.currency_code}`,
            boxX + boxWidth - 2,
            boxY + 7,
            { align: "right" }
            );
        });

        // === TOTAL GENERAL DEL PAGO ===
        const lastY = doc.lastAutoTable ? doc.lastAutoTable.finalY : 100;
        const totalBoxX = 120;
        const totalBoxY = lastY + 24;
        const totalBoxWidth = 70;
        const totalBoxHeight = 12;

        doc.setDrawColor(41, 128, 185);
        doc.setFillColor(41, 128, 185);
        doc.rect(totalBoxX, totalBoxY, totalBoxWidth, totalBoxHeight, "FD");

        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(255, 255, 255);
        doc.text("Total del Pago:", totalBoxX + 2, totalBoxY + 7);
        doc.text(
            `${currencyFormat(parseFloat(pago.total_amount))} ${pago.currency_code}`,
            totalBoxX + totalBoxWidth - 2,
            totalBoxY + 7,
            { align: "right" }
        );
        doc.setTextColor(0, 0, 0);

        doc.save(`Reporte_Pago_${pago.invoice_payment_id}.pdf`);
        }

    generarReporteTransaccion(transaccion) {
        const doc = new jsPDF();
        const details = transaccion.payment_transaction_details;
        let firstPage = true;

        details.forEach((detail) => {
            if (!firstPage) doc.addPage();
            firstPage = false;

            const destX = 120;

            // === TITULO ===
            doc.setFont("helvetica", "bold");
            doc.setFontSize(14);
            let cursorY = 12;
            doc.text(transaccion.business_unit_description || "", 105, cursorY, { align: "center" });

            if (transaccion.location_description) {
                cursorY += 5;
                doc.setFontSize(11);
                doc.text(transaccion.location_description, 105, cursorY, { align: "center" });
            }

            cursorY += 5;
            doc.setFontSize(10);
            doc.text(detail.entity_name || "", 105, cursorY, { align: "center" });

            cursorY += 5;
            doc.setFontSize(9);
            doc.setFont("helvetica", "normal");
            doc.text("DETALLES DEL PAGO", 105, cursorY, { align: "center" });

            cursorY += 5;
            doc.line(15, cursorY, 195, cursorY);
            cursorY += 3;

            // === DATOS GENERALES ===
            doc.setFont("helvetica", "normal");
            doc.setFontSize(8);

            doc.text(`SEQ: ${detail.payment_transaction_sequence}`, 20, cursorY + 3);
            doc.text(`Fecha de Pago: ${moment(transaccion.payment_date).format("DD/MM/YYYY")}`, destX, cursorY + 3);

            doc.text(`Tipo de Pago: ${transaccion.payment_type_name || ""}`, 20, cursorY + 7);
            doc.text(`Fecha impresión: ${moment().format('DD/MM/YYYY HH:mm')}`, destX, cursorY + 7);

            doc.text(`Elaborado por: ${transaccion.payment_by_name || ""}`, 20, cursorY + 11);
            doc.text(`Facturas del suplidor: ${detail.payment_transaction_invoice_details.length}`, destX, cursorY + 11);

            // === ORIGEN / DESTINO ===
            doc.setFont("helvetica", "bold");
            doc.text("Origen", 20, cursorY + 17);
            doc.text("Destino", destX, cursorY + 17);

            doc.setFont("helvetica", "normal");

            // Origen: empresa
            doc.text(`Cta. ${transaccion.bank_account_description_short || "No disponible"}`, 20, cursorY + 21);
            doc.text(transaccion.bank_account_description_long || "", 20, cursorY + 25);

            // Destino: beneficiario
            doc.text(detail.entity_name, destX, cursorY + 21);
            doc.text(
                `${detail.document_id_type_name || ""}: ${detail.entity_document_id || "N/D"}`,
                destX,
                cursorY + 25
            );
            doc.text(`Cta. ${detail.account || "No disponible"}`, destX, cursorY + 29);
            doc.text(detail.bank_account_description_long || "", destX, cursorY + 33);

            // === TABLA ===
            const columns = ["Factura", "Suplidor", "Referencia", "Monto Total", "Total Pagado"];
            const rows = detail.payment_transaction_invoice_details.map(inv => [
                inv.invoice_number,
                detail.entity_name.slice(0, 30),
                inv.supplier_invoice_number || "",
                `${currencyFormat(inv.invoice_total_amount)} ${detail.currency_code}`,
                `${currencyFormat(inv.payment_amount)} ${detail.currency_code}`
            ]);

            doc.autoTable({
                startY: cursorY + 38,
                head: [columns],
                body: rows,
                theme: "striped",
                styles: { fontSize: 7.5, cellPadding: 1.2, valign: "middle" },
                headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold", fontSize: 7.5 },
                alternateRowStyles: { fillColor: [245, 245, 245] },
                columnStyles: {
                    3: { halign: "right" },
                    4: { halign: "right" }
                }
            });

            // === TOTAL POR BENEFICIARIO ===
            const finalY = doc.lastAutoTable.finalY;

            if (transaccion.note) {
                const noteX = 20;
                const noteWidth = 95;
                const noteHeight = 12;
                const noteY = (finalY + 6 + noteHeight > doc.internal.pageSize.getHeight() - 10)
                    ? (doc.addPage(), 20)
                    : finalY + 6;

                doc.setDrawColor(0);
                doc.setFillColor(245, 245, 245);
                doc.rect(noteX, noteY, noteWidth, noteHeight, "FD");

                doc.setFontSize(8);
                doc.setFont("helvetica", "bold");
                doc.text("Nota:", noteX + 2, noteY + 5);

                doc.setFont("helvetica", "normal");
                doc.text(
                    doc.splitTextToSize(transaccion.note, noteWidth - 6),
                    noteX + 2,
                    noteY + 9
                );
            }

            const boxX = 120;
            const boxWidth = 70;
            const boxHeight = 12;
            const pageHeight = doc.internal.pageSize.getHeight();
            const neededY = finalY + 6 + boxHeight;
            const boxY = neededY > pageHeight - 10
                ? (doc.addPage(), 20)
                : finalY + 6;

            doc.setDrawColor(0);
            doc.setFillColor(235, 235, 235);
            doc.rect(boxX, boxY, boxWidth, boxHeight, "FD");

            doc.setFontSize(9);
            doc.setFont("helvetica", "bold");
            doc.text("Total Pagado:", boxX + 2, boxY + 7);

            doc.setFont("helvetica", "normal");
            doc.text(
                `${currencyFormat(detail.payment_amount)} ${detail.currency_code}`,
                boxX + boxWidth - 2,
                boxY + 7,
                { align: "right" }
            );
        });

        // === PÁGINA DE RESUMEN ===
        doc.addPage();
        const currencyCode = details[0]?.currency_code || "DOP";

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(transaccion.business_unit_description || "", 105, 15, { align: "center" });
        doc.setFontSize(10);
        doc.text("RESUMEN DE TRANSACCIÓN", 105, 21, { align: "center" });
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(`Transacción #${String(transaccion.payment_transaction_id).padStart(8, "0")}  |  ${transaccion.payment_type_name || ""}  |  Fecha: ${moment(transaccion.payment_date).format("DD/MM/YYYY")}`, 105, 26, { align: "center" });
        doc.line(15, 29, 195, 29);

        const summaryColumns = ["SEQ", "Beneficiario", "Cuenta", "Moneda", "Monto"];
        const summaryRows = details.map(d => [
            d.payment_transaction_sequence,
            d.entity_name,
            d.account || "",
            d.currency_code || "",
            currencyFormat(d.payment_amount)
        ]);

        doc.autoTable({
            startY: 33,
            head: [summaryColumns],
            body: summaryRows,
            theme: "striped",
            styles: { fontSize: 8, cellPadding: 1.5, valign: "middle" },
            headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold", fontSize: 8 },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: {
                0: { cellWidth: 20 },
                3: { halign: "center", cellWidth: 18 },
                4: { halign: "right", cellWidth: 35 }
            }
        });

        const summaryFinalY = doc.lastAutoTable.finalY;
        const totalBoxX = 120;
        const totalBoxY = summaryFinalY + 6;
        const totalBoxWidth = 70;
        const totalBoxHeight = 12;

        doc.setDrawColor(41, 128, 185);
        doc.setFillColor(41, 128, 185);
        doc.rect(totalBoxX, totalBoxY, totalBoxWidth, totalBoxHeight, "FD");

        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(255, 255, 255);
        doc.text("Total del Pago:", totalBoxX + 2, totalBoxY + 7);
        doc.text(
            `${currencyFormat(parseFloat(transaccion.payment_transaction_amount))} ${currencyCode}`,
            totalBoxX + totalBoxWidth - 2,
            totalBoxY + 7,
            { align: "right" }
        );
        doc.setTextColor(0, 0, 0);

        doc.save(`Reporte_Transaccion_${transaccion.payment_transaction_id}.pdf`);
    }

    // Listado pendiente (anexo al cheque): PDF con las facturas que NO caben en el
    // cheque (más allá de `maxPerCheck` líneas), por cada cheque que excede ese tope.
    // Devuelve true si generó el PDF, false si ningún cheque excede el tope.
    generarListadoPendiente(transaccion, maxPerCheck = 18) {
        const details = (transaccion.payment_transaction_details || []).filter(
            (d) => (d.payment_transaction_invoice_details || []).length > maxPerCheck
        );
        if (details.length === 0) return false;

        const doc = new jsPDF();
        const currencyCode = transaccion.payment_transaction_details?.[0]?.currency_code || "DOP";
        let firstPage = true;

        details.forEach((detail) => {
            if (!firstPage) doc.addPage();
            firstPage = false;

            // === ENCABEZADO ===
            doc.setFont("helvetica", "bold");
            doc.setFontSize(14);
            doc.text(transaccion.business_unit_description || "", 105, 14, { align: "center" });
            doc.setFontSize(10);
            doc.text("LISTADO PENDIENTE (ANEXO AL CHEQUE)", 105, 20, { align: "center" });

            doc.setFont("helvetica", "normal");
            doc.setFontSize(8);
            doc.text(
                `Transacción #${String(transaccion.payment_transaction_id).padStart(8, "0")}  |  Fecha: ${moment(transaccion.payment_date).format("DD/MM/YYYY")}  |  Impreso: ${moment().format("DD/MM/YYYY HH:mm")}`,
                105, 25, { align: "center" }
            );
            doc.line(15, 28, 195, 28);

            // === DATOS DEL CHEQUE / SUPLIDOR ===
            const all = detail.payment_transaction_invoice_details || [];
            const overflow = all.slice(maxPerCheck); // solo las que NO caben (19+)

            doc.setFont("helvetica", "bold");
            doc.setFontSize(9);
            doc.text(`Cheque #${detail.payment_transaction_sequence}`, 20, 35);
            doc.setFont("helvetica", "normal");
            doc.text(`Suplidor: ${detail.entity_name || ""}`, 20, 40);
            doc.text(
                `En el cheque: ${maxPerCheck}   |   En este anexo: ${overflow.length}   |   Total facturas: ${all.length}`,
                20, 45
            );

            // === TABLA: SOLO LAS FACTURAS QUE NO CABEN (19 en adelante) ===
            const columns = ["#", "Factura", "Fact. Suplidor", "Fecha", "Monto Factura", "Pagado", "Descuento", "Neto"];
            const rows = overflow.map((inv, i) => [
                maxPerCheck + i + 1,
                inv.invoice_number || "",
                inv.supplier_invoice_number || "",
                inv.emission_date ? moment(inv.emission_date).format("DD/MM/YYYY") : "",
                currencyFormat(inv.invoice_total_amount),
                currencyFormat(inv.payment_amount),
                currencyFormat(inv.discount_amount || 0),
                currencyFormat((inv.payment_amount || 0) - (inv.discount_amount || 0)),
            ]);

            doc.autoTable({
                startY: 50,
                head: [columns],
                body: rows,
                theme: "striped",
                styles: { fontSize: 7.5, cellPadding: 1.2, valign: "middle" },
                headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold", fontSize: 7.5 },
                alternateRowStyles: { fillColor: [245, 245, 245] },
                columnStyles: {
                    0: { halign: "center", cellWidth: 10 },
                    4: { halign: "right" },
                    5: { halign: "right" },
                    6: { halign: "right" },
                    7: { halign: "right" },
                },
            });

            // === TOTAL DEL ANEXO ===
            const finalY = doc.lastAutoTable.finalY;
            const totalAnexo = overflow.reduce(
                (s, inv) => s + ((inv.payment_amount || 0) - (inv.discount_amount || 0)), 0
            );
            const boxX = 120, boxWidth = 70, boxHeight = 12;
            const boxY = finalY + 6 + boxHeight > doc.internal.pageSize.getHeight() - 10
                ? (doc.addPage(), 20)
                : finalY + 6;
            doc.setDrawColor(0);
            doc.setFillColor(235, 235, 235);
            doc.rect(boxX, boxY, boxWidth, boxHeight, "FD");
            doc.setFontSize(9);
            doc.setFont("helvetica", "bold");
            doc.text("Total anexo:", boxX + 2, boxY + 7);
            doc.setFont("helvetica", "normal");
            doc.text(
                `${currencyFormat(totalAnexo)} ${detail.currency_code || currencyCode}`,
                boxX + boxWidth - 2, boxY + 7, { align: "right" }
            );
        });

        doc.save(`Listado_Pendiente_${transaccion.payment_transaction_id}.pdf`);
        return true;
    }

    async exportarTransaccionesExcel(transactions) {
        const workbook = new ExcelJS.Workbook();
        const hFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2980B9' } };
        const hFont = { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 };
        const bdr   = { style: 'thin', color: { argb: 'FFD0D0D0' } };
        const allB  = { top: bdr, left: bdr, bottom: bdr, right: bdr };
        const vFont = { size: 9 };
        const amtFmt = '#,##0.00';

        const ws = workbook.addWorksheet('Transacciones');
        ws.columns = [
            { key: 'A', width: 14 },  // ID Transacción
            { key: 'B', width: 28 },  // Cuenta Bancaria
            { key: 'C', width: 26 },  // Nombre Cuenta
            { key: 'D', width: 18 },  // Tipo Pago
            { key: 'E', width: 14 },  // Fecha Pago
            { key: 'F', width: 12 },  // Estado
            { key: 'G', width: 12 },  // SEQ
            { key: 'H', width: 34 },  // Suplidor
            { key: 'I', width: 20 },  // Cuenta Suplidor
            { key: 'J', width: 10 },  // Moneda
            { key: 'K', width: 16 },  // Monto
        ];

        const headers = ['Transacción', 'Cuenta Bancaria', 'Nombre Cuenta', 'Tipo Pago', 'Fecha Pago', 'Estado', 'SEQ', 'Suplidor', 'Cuenta Suplidor', 'Moneda', 'Monto'];
        const cols = ['A','B','C','D','E','F','G','H','I','J','K'];

        headers.forEach((h, i) => {
            const cell = ws.getCell(`${cols[i]}1`);
            cell.value = h;
            cell.font = hFont;
            cell.fill = hFill;
            cell.border = allB;
            cell.alignment = { horizontal: i >= 10 ? 'right' : 'left', vertical: 'middle' };
        });

        let row = 2;
        transactions.forEach((tx) => {
            const txId = `#${String(tx.payment_transaction_id).padStart(8, '0')}`;
            const details = tx.payment_transaction_details || [];

            const rowsToWrite = details.length > 0 ? details : [null];
            rowsToWrite.forEach((detail) => {
                const bg = { type: 'pattern', pattern: 'solid', fgColor: { argb: row % 2 === 0 ? 'FFFFFFFF' : 'FFF5F5F5' } };
                const set = (col, val, align = 'left', numFmt = null) => {
                    const c = ws.getCell(`${col}${row}`);
                    c.value = val; c.font = vFont; c.fill = bg; c.border = allB;
                    c.alignment = { horizontal: align };
                    if (numFmt) c.numFmt = numFmt;
                };
                set('A', txId);
                set('B', tx.bank_account_description_long || '');
                set('C', tx.account_name || '');
                set('D', tx.payment_type_name || '');
                set('E', moment(tx.payment_date).format('DD/MM/YYYY'));
                set('F', tx.status_name || '');
                set('G', detail ? detail.payment_transaction_sequence : '');
                set('H', detail ? detail.entity_name || '' : '');
                set('I', detail ? `${detail.account || ''} - ${detail.account_type_name || ''}` : '');
                set('J', detail ? detail.currency_code || '' : '', 'center');
                set('K', detail ? parseFloat(detail.payment_amount) || 0 : parseFloat(tx.payment_transaction_amount) || 0, 'right', amtFmt);
                row++;
            });
        });

        // total general
        ws.mergeCells(`A${row}:J${row}`);
        const totCell = ws.getCell(`A${row}`);
        totCell.value = 'TOTAL GENERAL';
        totCell.font = hFont;
        totCell.fill = hFill;
        totCell.border = allB;
        totCell.alignment = { horizontal: 'right' };

        const grandTotal = transactions.reduce((s, tx) => s + (parseFloat(tx.payment_transaction_amount) || 0), 0);
        const totAmtCell = ws.getCell(`K${row}`);
        totAmtCell.value = grandTotal;
        totAmtCell.numFmt = amtFmt;
        totAmtCell.font = hFont;
        totAmtCell.fill = hFill;
        totAmtCell.alignment = { horizontal: 'right' };
        totAmtCell.border = allB;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Reporte_Transacciones_${moment().format('YYYY-MM-DD')}.xlsx`;
        link.click();
    }

    async exportarTransaccionExcel(transaccion) {
        const workbook = new ExcelJS.Workbook();
        const details = transaccion.payment_transaction_details;
        const hFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2980B9' } };
        const hFont = { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 };
        const bdr   = { style: 'thin', color: { argb: 'FFD0D0D0' } };
        const allB  = { top: bdr, left: bdr, bottom: bdr, right: bdr };
        const vFont = { size: 9 };
        const amtFmt = '#,##0.00';

        // === HOJA DETALLE ===
        const wsDetail = workbook.addWorksheet('Detalle');
        wsDetail.columns = [
            { key: 'A', width: 10 },  // SEQ
            { key: 'B', width: 30 },  // Suplidor
            { key: 'C', width: 22 },  // Factura
            { key: 'D', width: 22 },  // Referencia suplidor
            { key: 'E', width: 14 },  // Fecha emisión
            { key: 'F', width: 16 },  // Monto total
            { key: 'G', width: 16 },  // Total pagado
            { key: 'H', width: 10 },  // Moneda
        ];

        // Título
        wsDetail.mergeCells('A1:H1');
        wsDetail.getCell('A1').value = transaccion.business_unit_description || '';
        wsDetail.getCell('A1').font = { bold: true, size: 13 };
        wsDetail.getCell('A1').alignment = { horizontal: 'center' };

        wsDetail.mergeCells('A2:H2');
        wsDetail.getCell('A2').value = `Transacción #${String(transaccion.payment_transaction_id).padStart(8, '0')}  |  ${transaccion.payment_type_name || ''}  |  ${moment(transaccion.payment_date).format('DD/MM/YYYY')}  |  Elaborado por: ${transaccion.payment_by_name || ''}`;
        wsDetail.getCell('A2').font = { size: 9 };
        wsDetail.getCell('A2').alignment = { horizontal: 'center' };

        // Encabezados
        const detailHeaders = ['SEQ', 'Suplidor', 'Factura', 'Ref. Suplidor', 'Fecha Emisión', 'Monto Total', 'Total Pagado', 'Moneda'];
        detailHeaders.forEach((h, i) => {
            const col = String.fromCharCode(65 + i);
            const cell = wsDetail.getCell(`${col}4`);
            cell.value = h;
            cell.font = hFont;
            cell.fill = hFill;
            cell.border = allB;
            cell.alignment = { horizontal: i >= 5 ? 'right' : 'left' };
        });

        // Filas de detalle
        let detailRow = 5;
        details.forEach((detail) => {
            detail.payment_transaction_invoice_details.forEach((inv, idx) => {
                const bg = detailRow % 2 === 0
                    ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } }
                    : { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F5F5' } };

                const setD = (col, val, align = 'left', numFmt = null) => {
                    const c = wsDetail.getCell(`${col}${detailRow}`);
                    c.value = val;
                    c.font = vFont;
                    c.fill = bg;
                    c.border = allB;
                    c.alignment = { horizontal: align };
                    if (numFmt) c.numFmt = numFmt;
                };

                setD('A', detail.payment_transaction_sequence);
                setD('B', detail.entity_name);
                setD('C', inv.invoice_number);
                setD('D', inv.supplier_invoice_number || '');
                setD('E', inv.emission_date ? moment(inv.emission_date).format('DD/MM/YYYY') : '');
                setD('F', parseFloat(inv.invoice_total_amount) || 0, 'right', amtFmt);
                setD('G', parseFloat(inv.payment_amount) || 0, 'right', amtFmt);
                setD('H', detail.currency_code || '', 'center');
                detailRow++;
            });
        });

        // Total general en detalle
        detailRow++;
        wsDetail.mergeCells(`A${detailRow}:F${detailRow}`);
        wsDetail.getCell(`A${detailRow}`).value = 'Total del Pago:';
        wsDetail.getCell(`A${detailRow}`).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 };
        wsDetail.getCell(`A${detailRow}`).fill = hFill;
        wsDetail.getCell(`A${detailRow}`).border = allB;

        wsDetail.getCell(`G${detailRow}`).value = parseFloat(transaccion.payment_transaction_amount) || 0;
        wsDetail.getCell(`G${detailRow}`).numFmt = amtFmt;
        wsDetail.getCell(`G${detailRow}`).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 };
        wsDetail.getCell(`G${detailRow}`).fill = hFill;
        wsDetail.getCell(`G${detailRow}`).alignment = { horizontal: 'right' };
        wsDetail.getCell(`G${detailRow}`).border = allB;

        wsDetail.getCell(`H${detailRow}`).value = details[0]?.currency_code || '';
        wsDetail.getCell(`H${detailRow}`).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 };
        wsDetail.getCell(`H${detailRow}`).fill = hFill;
        wsDetail.getCell(`H${detailRow}`).alignment = { horizontal: 'center' };
        wsDetail.getCell(`H${detailRow}`).border = allB;

        // === HOJA RESUMEN ===
        const wsSummary = workbook.addWorksheet('Resumen');
        wsSummary.columns = [
            { key: 'A', width: 10 },
            { key: 'B', width: 34 },
            { key: 'C', width: 22 },
            { key: 'D', width: 18 },
            { key: 'E', width: 18 },
        ];

        wsSummary.mergeCells('A1:E1');
        wsSummary.getCell('A1').value = transaccion.business_unit_description || '';
        wsSummary.getCell('A1').font = { bold: true, size: 13 };
        wsSummary.getCell('A1').alignment = { horizontal: 'center' };

        wsSummary.mergeCells('A2:E2');
        wsSummary.getCell('A2').value = `Transacción #${String(transaccion.payment_transaction_id).padStart(8, '0')}  |  ${transaccion.payment_type_name || ''}  |  ${moment(transaccion.payment_date).format('DD/MM/YYYY')}`;
        wsSummary.getCell('A2').font = { size: 9 };
        wsSummary.getCell('A2').alignment = { horizontal: 'center' };

        const summaryHeaders = ['SEQ', 'Beneficiario', 'Cuenta', 'Moneda', 'Monto'];
        const sCols = ['A', 'B', 'C', 'D', 'E'];
        summaryHeaders.forEach((h, i) => {
            const cell = wsSummary.getCell(`${sCols[i]}4`);
            cell.value = h;
            cell.font = hFont;
            cell.fill = hFill;
            cell.border = allB;
            cell.alignment = { horizontal: i >= 3 ? 'right' : 'left' };
        });

        details.forEach((detail, idx) => {
            const r = 5 + idx;
            const bg = idx % 2 === 0
                ? { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } }
                : { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F5F5' } };
            const setS = (col, val, align = 'left', numFmt = null) => {
                const c = wsSummary.getCell(`${col}${r}`);
                c.value = val;
                c.font = { size: 9 };
                c.fill = bg;
                c.border = allB;
                c.alignment = { horizontal: align };
                if (numFmt) c.numFmt = numFmt;
            };
            setS('A', detail.payment_transaction_sequence);
            setS('B', detail.entity_name);
            setS('C', detail.account || '');
            setS('D', detail.currency_code || '', 'center');
            setS('E', parseFloat(detail.payment_amount) || 0, 'right', '#,##0.00');
        });

        const totalRow = 5 + details.length;
        wsSummary.mergeCells(`A${totalRow}:D${totalRow}`);
        wsSummary.getCell(`A${totalRow}`).value = 'Total del Pago:';
        wsSummary.getCell(`A${totalRow}`).font = { bold: true, size: 10 };
        wsSummary.getCell(`A${totalRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2980B9' } };
        wsSummary.getCell(`A${totalRow}`).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 };
        wsSummary.getCell(`A${totalRow}`).border = allB;

        wsSummary.getCell(`E${totalRow}`).value = parseFloat(transaccion.payment_transaction_amount) || 0;
        wsSummary.getCell(`E${totalRow}`).numFmt = '#,##0.00';
        wsSummary.getCell(`E${totalRow}`).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 10 };
        wsSummary.getCell(`E${totalRow}`).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2980B9' } };
        wsSummary.getCell(`E${totalRow}`).alignment = { horizontal: 'right' };
        wsSummary.getCell(`E${totalRow}`).border = allB;

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Reporte_Transaccion_${transaccion.payment_transaction_id}.xlsx`;
        link.click();
    }
}


function deleteDiacriticos(texto) {

    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
}
function filRight(str, length, add) {//rellena caracteres a la derecha
    while (str.length < length) {
        str += add;
    } return str;
}
function filLeft(str, length, add) {//rellena caracteres a la izauierda
    while (str.length < length) {
        str = add + str;
    }
    return str;
}

function currencyFormat(number) {
    if (number == null || number == undefined) {
        return '0.00'
    }
    number = parseFloat(number);
    const formated = number.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        currencySign: 'accounting',
        minimumFractionDigits: 2,
    });
    return formated.replace('$', '');
}
function filCenter(str, max) {//centra
    let size = str.length;
    if (size > max) { return str.slice(0, max); }
    function addSpacer(cant) {
        let spacers = "";
        for (let x = 0; x < cant; x++) {
            spacers += " ";
        }
        return spacers;
    }
    return addSpacer((max - size) / 2) + str + addSpacer((max - size) / 2);
}
export default new ReportFunctions();